import { AbstractControl, ValidationErrors } from "@angular/forms";

export function validateAccountNumbers(control: AbstractControl): ValidationErrors | null {

    const { accountNumber, confirmAccountNumber } = control.value;

    // avoid displaying the message error when values are empty
    if (!accountNumber || !confirmAccountNumber) {
        return null;
    }

    if (confirmAccountNumber === accountNumber) {
        return null;
    }

    return { mustMatchAccountNumbers: true };
}